export async function createSpreadsheetBlob(sheetData, sheetOptions) {
  const writeExcelFileModule = await import('write-excel-file/browser')
  const writeExcelFile = writeExcelFileModule.default || writeExcelFileModule

  return writeExcelFile(sheetData, sheetOptions).toBlob()
}
